import React  from 'react'
import { BrowserRouter, Match } from 'react-router'

import Homepage from "./Homepage"
import EpisodePage from './EpisodePage'
import Members from './Members/Members'
import Footer from "./Footer"
import { isBrowser } from "../lib/utils"

export default () => (
  <BrowserRouter>
    <div>
      <Match exactly pattern="/" component={Homepage}/>
      <Match exactly pattern="/members" component={Members}/>
      <Match pattern="/ep:episodeNr" render={props => {
        if (isBrowser) window.scrollTo(0, 0)
        return <EpisodePage {...props}/>
      }}/>
      {/*<Match pattern="/episodes" component={EpisodesList}/>*/}
      <Footer/>
    </div>
  </BrowserRouter>
)



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/